import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBookings } from "../../../redux/actions/bookings";
import { hideModal, setModal } from "../../../redux/actions/modals";
import { State } from "../../../redux/reducers/root";
import { Booking, Schedule } from "../../../redux/types";
import { useQuery } from "../../../utils/hooks";
import BookingItem from "../../bookings/booking-item";
import Button from "../button";
import { EDIT_SCHEDULE_MODAL, FOLLOWUP_SCHEDULE_MODAL } from "./constants";
import ModalTemplate from "./template";

const FollowupSchedule = () => {
  const modals = useSelector((state: State) => state.modals);
  const { schedule, conflictedBooking, doctorId } = modals.data as {
    schedule: Schedule;
    conflictedBooking: Booking[];
    doctorId: string;
  };
  const query = useQuery();
  const officeId = query.get("office")!;
  // const bookings = useSelector((state: State) => state.bookings);
  // // const bookingData = officeId && bookings[parseInt(officeId)];
  // sort conflictedBooking by date
  conflictedBooking.sort((a, b) => {
    return parseInt(a.timeslot.dateTime) - parseInt(b.timeslot.dateTime);
  });

  const [disableSubmit, setDisableSubmit] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  let pendingBooking: any = [];
  let updateConflictedBooking: any = [];
  const dispatch = useDispatch();

  const setisClickedStateSetter = useCallback(
    (val: any) => {
      setIsClicked(val);
    },
    [setIsClicked]
  );

  const updateConflicted = async () => {
    updateConflictedBooking = (
      (await dispatch(fetchBookings(Number(doctorId), { weekDay: schedule.weekDay, officeId: officeId }))) as any
    ).payload?.data;
    pendingBooking = updateConflictedBooking.filter((booking: any) => !booking.checked);
    pendingBooking.length > 0 ? setDisableSubmit(true) : setDisableSubmit(false);
    dispatch(
      setModal({
        modal: FOLLOWUP_SCHEDULE_MODAL,
        data: { schedule, conflictedBooking: updateConflictedBooking, doctorId },
        visible: true,
      })
    );
  };

  useEffect(() => {
    updateConflicted();
  }, [isClicked, schedule]);

  const hide = () => {
    dispatch(hideModal());
  };

  const submitEditTimeSlot = () => {
    dispatch(setModal({ modal: EDIT_SCHEDULE_MODAL, data: { schedule, doctorId }, visible: true }));
  };

  return (
    <ModalTemplate titleClass="text-base" title="مغایرت در رزروها و برنامه جدید" icon="fa fa-calendar-alt">
      <hr className="my-3" />
      <div className="p-2 font-medium border-solid rounded-md bg-pkc-red-15 border-1 border-pkc-red text-pkc-red">
        <p>
          رزروهای زیر با توجه به برنامه وقت‌دهی قبلی شما ثبت شده است. لطفا جهت اعمال تغییر در وقت‌دهی، ابتدا این رزرو‌ها
          را بررسی و تعیین تکلیف نموده و سپس تغییر برنامه را تایید فرمایید.
        </p>
      </div>
      <hr className="my-3" />
      <div className="flex flex-col">
        <div className="mb-3 font-medium">{conflictedBooking.length} رزرو نیازمند بررسی</div>
        <div className="overflow-y-scroll max-h-80">
          {conflictedBooking.map((booking: Booking) => (
            <BookingItem
              key={booking.id}
              booking={booking}
              doctorId={Number(doctorId)}
              stateSetter={setisClickedStateSetter}
            />
          ))}
        </div>
        <div className="flex justify-between px-1 py-4">
          <Button variant="outline" className="w-1/2 ml-2" onClick={hide}>
            انصراف
          </Button>
          <Button variant="contained" className="w-1/2" onClick={submitEditTimeSlot} disabled={disableSubmit}>
            تایید تغییر برنامه
          </Button>
        </div>
      </div>
    </ModalTemplate>
  );
};

export default FollowupSchedule;
